import { render, staticRenderFns } from "./KnittedTrims.vue?vue&type=template&id=161112b9"
import script from "./KnittedTrims.vue?vue&type=script&lang=js"
export * from "./KnittedTrims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports